import { Box, Divider } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import useSWR from 'swr';

import AvailabilityCalendar from '../../components/customer/meetings/availabilityCalendar';
import MeetingHeader from '../../components/customer/meetings/common/tabHeader';
import MeetingList from '../../components/customer/meetings/meetingList';
import { useAuth } from '../../contexts/auth/authContext';
import { setItems, setLoading } from '../../slices/tenantUserListSlice';

interface UserFromAPI {
  id: number;
  full_name: string;
}

const pageStyle = {
  border: '1px solid #D6D6D6',
  borderRadius: '6px',
  bgcolor: '#FFFFFF',
};

export const TABS = {
  SCHEDULED: 0,
  AVAILABILITY: 1,
};


const CustomerMeetingsPage = () => {  
  const dispatch = useDispatch();
  const { slug } = useAuth();
  const [companySlug, setCompanySlug] = useState<string | null>(slug);
  const [selectedTab, setSelectedTab] = useState<number>(0);

  useEffect(() => {
    if (!slug) {
      setCompanySlug(localStorage.getItem('slug'));
    }
  }, [slug]);


    
  const { data: userList, isLoading: userListLoading } = useSWR(companySlug ? `tenant/${companySlug}/settings/report-form` : '', { revalidateOnFocus: false });


  useEffect(() => {
    dispatch(setLoading(userListLoading));
    if (userList) {
      dispatch(setItems(userList?.tenant_users?.map(({ id, full_name }: UserFromAPI) => ({ id, name: full_name }))));
    }
  }, [userList, userListLoading, dispatch]);


  return (
    <Box sx={pageStyle}>
      <MeetingHeader 
        selectedTab={selectedTab} 
        setSelectedTab={setSelectedTab}
      />
      <Divider/>
      {selectedTab === TABS.SCHEDULED &&
        <Box sx={{ padding: '20px 0px 20px 20px' }}>
          <MeetingList/>
        </Box>
      }
      {selectedTab === TABS.AVAILABILITY && 
        <Box sx={{ paddingBottom: '20px' }}>
          <AvailabilityCalendar/>
        </Box>
      }
    </Box>
  );
};

export default CustomerMeetingsPage;